export const login = {
    title: 'Sign in to your account',
    forgotPassword: 'Forgot Password?',
    notAMember: 'Not a member?',
    register: 'Register now!',
    forgotPasswordTitle: 'Forgot Password',
    forgotPasswordContent: "<p class='pb-3'>Enter your email address and we will send you a link to reset your password</p>",
    forgotPasswordButton: 'Send Reset Link',
    forgotPasswordSuccess: `<b>Password Reset Link Sent!</b><p class='pt-2'>If we found an account with the email address you entered, we've sent password reset instructions to the email address you provided. Please check your email.</p>`,
    invalidCredentials: "Invalid user credentials",
    changePassword: "Change password",
    requirePasswordChange: "We require that you change your password"
}

export const registration = {
    title: "#1 Digital Food Safety System",
    register: "Register",
    registrationComplete: "Registration Complete",
    registrationCompleteContent: `<p class="py-3">Thanks for registering. You will soon receive an email asking for you to confirm your email address.</p>`,
    next: `Next`,
    registerNow: "Start Your Free Trial Now",
    registerOffer: "",
    registerTrialDays: "14",
    registerDays: "DAYS",
    registerFree: "FREE"
}

export const authorize = {
    accountNotFound: `<h1 class="py-5 text-2xl text-center font-bold">Account could not be found</h1>
                        <p class="p-3">Your account could not be found registered on our system.</p>
                        <p class="p-3">Please ensure you clicked on the correct link in your registration email.</p>
                        <p class="p-3">If you have further issues please contact <a class="text-blue-900" href='mailto:help{'@'}checkmate.software'>help{'@'}checkmate.software</a></p>`,
    accountAlreadyAuthorized: `<h1 class="py-5 text-2xl text-center font-bold">Account is already authorized</h1>
                                <p class="p-3">Your account has already been authorized, try logging in</p>
                                <p class="p-3">If you have further issues please contact <a class="text-blue-900" href='mailto:help{'@'}checkmate.software'>help{'@'}checkmate.software</a></p>`,
    title: "Account Invitation",
    passwordContent: `<p class="py-3">Thanks for verifying your account with CheckMate! While we're getting everything ready for you we have a few we questions to complete your account</p>
                        <p class="py-3">First we need to setup your password so you can access your account</p>`,
    checkSetup: "Setup your checks",
    checkSetupContent: `<p class="py-3">We have a set of template checks that follow the Smarter Business Food Safety Standards which I can automatically set up for you. </p>
                        <p class="py-3">To do that I need some information about your fridges, freezers and ovens. Give each one a name that you can remember and tell us what type is it.</p>
                        <p class="py-3">Note: This can be setup later, if you skip this section we will setup your initial checks with 1 fridge, 1 freezer and 1 oven.</p>`,
    skip: "Skip this step and setup later",
    resetpasswordsuccess: "Password Reset Successful",
    loginToAccept: "Please login to your account accept the invite.",
    wrongAccount: "You’re signed in with a different account than the one invited. Please log out and sign in with the correct account.",
    inviteInvalid: "This invitation is no longer valid, please login to you account.",
    inviteResent: "Invitation re-sent"
}

export const devices = {
    myDevices: "My Devices",
    type: "Type",
    name: "Friendly Name",
    namePlaceholder: "Friendly Name (e.g. Under-counter Fridge)"
}

export const checks = {
    iconAndName: "Icon & Name",
    deletecheck: "Are you sure you want to delete this check?",
    checks: "Checks",
    icon: "Icon",
    addDropdownOption: "Add dropdown option",
    option: "Option",
    name: "Name",
    schedule: "Schedule",
    duetime: "Due Time",
    status: "Status",
    published: "Published",
    draft: "Draft",
    retrospective: "Add Retrospective Check",
    addTask: "Add Task",
    fromAppliance: "From Appliance",
    taskType: "Task Type",
    isCCP: "Is CCP",
    title: "Title",
    message: "Message",
    alarmAfter: "Set task to alarm after",
    minutes: "minutes",
    skipped: "Task can be skipped?",
}

export const correctiveActions = {
    "addCorrectiveAction": "Add corrective action",
    "correctiveActions": "Corrective Actions",
    "general": "General",
    "lessThanMinimum": "Less than minimum",
    "moreThanMaximum": "More than maximum",
    "lessThanMinTemp": "Less than minimum temperature ({temp}°C)",
    "lessThanMinTempGeneral": "Less than minimum temperature",
    "moreThanMaxTemp": "More than maximum temperature ({temp}°C)",
    "moreThanMaxTempGeneral": "More than maximum temperature"
}

export const issuesPage = {
    addNote: "Add Note",
    reportIssue: "Report Issue",
    massResolve: "Mass Resolve",
    massResolveMessage: "Are you sure you want to resolve {count} issues?",
    issueResolved: "Issue Resolved",
    addAnIssue: "Add an issue",
    high: "High",
    low: "Low",
    resolveSelected: "Resolve selected",
    issueReported: "Issue Reported: ",
    markAsResolved: "Mark as Resolved",
    categorySaved: "Categories updated",
    actions: {
        markResolved: "Mark as Resolved",
        assignCategories: "Assign Categories",
        emailToContact: "Email to Contact",
        addAttachment: "Add Attachment"
    },
    modal: {
        addComment: "Add a comment... type {'@'} to mention someone",
        selectContact: "Select a contact",
        selectCategories: "Select Categories",
        noActivity: "No activity yet.",
        emailSent: "Email Sent",
        emailSentDetail: "Email sent to {email}",
        emailSendFailed: "Could not send email to the contact. Please try again.",
        noCategories: "Click to select category",
        download: "Download",
        newCategoryName: "New category name...",
        optionalMessage: "Message (optional)",
        emailMessagePlaceholder: "Optional message to include in the email...",
        addContact: "Add New Contact",
        contactName: "Contact Name",
        contactEmail: "Contact Email",
        contactAdded: "Contact added",
        deleteAttachmentConfirm: "Delete this attachment?",
        deleteAttachmentFailed: "Could not delete attachment",
        resolveReason: "Reason for resolving",
        resolveReasonPlaceholder: "Describe how this issue was resolved..."
    }
}

export const reports = {
    "reports": "Reports",
    "copyright": "Audit records for #location# generated on #date#. Provided by CheckMate",
    "completed": "Completed on ",
    "by": " by ",
    "daterange": "Date Range",
    "day": "Day",
    "daterangereport": "Date Range Check Report",
    "dayreport": "Daily Check Report",
    "download": "Generate & download report",
    "dayreportdownloaded": "Daily Check Report Generated Successfully",
    "daterangereportdownloaded": "Date Range Check Report Downloaded",
    "dayreportdownloadedmessage": "Your report has been generated and downloaded onto your device",
    "daterangereportdownloadedmessage": "Your report has been generated and downloaded onto your device",
    "noreport": "Report not available",
    "noreportmessage": "No data for this timeframe or filters, please change your date range or filter options and try again.",
    "showreport": "Show Report",
    "tenantlistdescription": "Get & download a list of all accounts and their current subscriptions as of midnight this morning",
    "tenantlisttitle": "Tenants Report (CheckMate only)",
    "dailyreportdescription": "Create a PDF report of all checks and issues for a specific day",
    "generalissues": "General Issues",
    "allissues": "All Issues",
    "accepted": "RESOLVED",
    "issues": "Issues",
    "issueon": "Issue on ",
    "generalissueincheck": "General issue in Check",
    "lastcompletedcheck": "Last Completed Check",
    "nextpaymentdue": "Next Payment Due",
    "tenantstatistics": "Tenant Statistics",
    "reportedissues": "Reported Issues",
    "skipped": "Skipped",
    "nocompletedchecks": "No complete checks found",
    "issuereportdescription": "Create a PDF report of all issues for a specific date range",
    "issuereport": "Issue Report",
    "issuecsvreport": "Issue CSV Export",
    "issuecsvreportdescription": "Export all issues for a specific date range to a CSV file",
    "reportdownloaded": "Report Downloaded",
    "reportdownloadedmessage": "Your report has been generated and downloaded onto your device",
    "downloadcsv": "Download CSV",
    "issuedate": "Issue Date",
    "checkcsvreport": "Check CSV Export",
    "checkcsvreportdescription": "Export all completed checks for a specific date range to a CSV file",
    "checkname": "Check Name",
    "schedule": "Schedule",
    "datecompleted": "Date Completed",
    "signees": "Signees",
    "daterangemessage": "Select a date range to generate a report",
    "tomanydates": "Cannot create report",
    "tomanydatesdescription": "Please choose a date range of 2 weeks or less",
    "tomanydatesdescriptionmonth": "Please choose a date range of 1 month or less",
    "reportfailedmessage": "Something went wrong generating the report. Please try again.",
    "subscribedLocations": "Subscribed Locations",
    "activeToday": "Active Today <br>(Total)",
    "activeTodaySubs": "Active Today <br>(subscribers)",
    "activeTodayTrial": "Active Today <br />(trial)",
    "checksComplete": "Checks Complete <br>(yesterday)",
    "issuesReported": "Issues Reported <br>(yesterday)"
}

export const user = {
    "firstname": "First Name",
    "lastname": "Last Name",
    "email": "Email",
    "phone": "Phone",
    "confirmpassword": "Confirm Password",
    "role": "User Type",
    "locations": "Locations",
    "available": "Available",
    "selected": "Selected",
    "resetpassword": "Password Reset",
    "btnresetpassword": "Reset Password",
    "emailAddress": "Email Address",
    "defaultLocation": "Default Location",
    "userType": "User Type",
    "status": "Status",
    "sendPasswordResetEmail": "Send Password Reset Email",
    "disableUser": "Disable User",
    "enableUser": "Enable User",
    "personalInformation": "Personal Information",
    "accountsUsersLimitedAccess": "Accounts users have limited access only to the subscription settings",
    "adminUsersAllLocations": "Admin users automatically get access to all locations",
    "notificationSettings": "Notification Settings",
    "notificationSettingsDescription": "Here you can disable/enable the email notifications you receive from CheckMate.",
    "addUser": "Add User",
    "editUser": "Edit User",
    "changePassword": "Change Password",
    "myProfile": "My Profile",
    "user": "User",
    "users": "Users",
    "confirmRevokeUser": "Are you sure you want to revoke this invitation?",
    "confirmDisableUser": "Are you sure you want to disable this user?",
    "weeklyComplianceEmail": "Weekly compliance Email",
    "highPriorityIssueEmailNotification": "High priority issue email notification",
    "lowPriorityIssueEmailNotification": "Low priority issue email notification",
    "mustSelectOneLocation": "You must select at least one location",
    "invitedOn": "Invited On",
    "pendingInvitations": "Pending Invitations",
    "resendInvite": "Resend invitation",
    "userAddTypes": "Inviting a user sends them an email inviting them to join or register for your account. Creating a local user allows you to create and register the user on their behalf.",
    "emailAddressExists": "A user already exists for that email address, please invite them to you account instead by using the Invite button above."
}

export const settings = {
    "payment": {
        "create": `<div class="text-center p-10 flex items-center flex-col">
            <img src='/tick-only.png' class="inline" style='width: 20%' /> 
            <p class="p-10">Your payment details have been successfully added. </p>
        </div>`,
        "createtitle": "Success",
        "cancel": "Your cancellation has been processed, from this point on your historical data will still be accessible to you.",
        "canceltitle": "We're sorry to see you go",
        "update": `<div class="text-center p-10 flex items-center flex-col">
            <img src='/tick-only.png' class="inline" style='width: 20%' /> 
            <p class="p-10">You have successfully updated your payment method.</p>
        </div>`,
        "updatetitle": "Payment Update Successful",
        "fail": `<div class="text-center p-10 flex items-center flex-col">
            <i class="fa fa-times text-red-500" style="font-size: 18em"></i> 
            <p class="p-10">Your payment details failed to proccess, please try again. </p>
        </div>`,
        "failtitle": "Payment Failure",
        "paymenttitle": "Payment Processing..."
    },
    "subscription": {
        "subscriptionExpiry": "You have an active subscription, it will expire on {date}",
        "restoreSubscription": "Restore Subscription",
        "confirmCancellationUpper": `<p class='mb-2'><strong>We're sorry to see you go</strong></p>
            <p class='mb-8'>Are you sure you want to unsubscribe from CheckMate? Staying subscribed means you'll continue to have access to all your peronsalised food safety checks and help your kitchen stay compliant.
            If you need assistance with anything, we are here to help just email us on <a class='text-blue-500' href='mailto:support{'@'}checkmate.software'>support{'@'}checkmate.software</a>.</p>
            <p class='mb-1'><strong>Before you go, please let us know how we can improve.</strong></p>`,
        "confirmCancellationLower": `<p class='mt-6 mb-2'>If your certain, just click below to confirm the end of your subscription. Thank you for using CheckMate, and remember your always welcome back!</p>`,
        "locations": "Locations",
        "location": "location",
        "cancel": "Cancel Subscription",
        "updateMethod": "Update Payment Method",
        "seeHowItWorks": "See how our pricing works",
        "costCalculation": "Cost is calculated based on number of locations.",
        "noOfLocations": "Number of active locations under this account",
        "addPaymentMethod": "Add Payment method",
        "chooseSubscription": "Choose a subscription",
        "bill": "Bill",
        "savePercent": "Save 20%!",
        "oneLocation": "1 x Location",
        "twoToTenLocations": "2 - 10 x Locations",
        "elevenPlusLocations": "11+ Locations",
        "perMonth": "per month",
        "perLocationMonth": "per location / month",
        "youCurrentlyHave": "You currently have {count} {locations}",
        "plusVAT": "+ VAT",
        "subscribe": "Subscribe",
        "cost": "Cost",
        "nextPaymentDue": "Next Payment Due",
        "usefulPaymentLinks": "Useful payment links",
        "paymentHistory": "Payment History",
        "date": "Date",
        "description": "Description",
        "amount": "Amount (inc VAT)",
        "btnUnsubscribe": "Yes, I want to unsubscribe",
        "btnStaySubscribed": "No, take me back",
        "account": "Account"
    }

}

export const calendar = {
    "calendar": "Calendar",
}

export const documents = {
    "title": "Documents",
    "upload": "Upload Files",
    "columnName": "Filename",
    "columnDateCreated": "Created Date",
    "columnCreatedBy": "Uploaded By",
    "newFolder": "New Folder",
    "moveFile": "Move File",
    "folderToMoveTo": "Folder to move to:",
    "name": "Name:",
    "confirmDelete": "Are you sure you want to delete this file?",
    "confirmation": "Confirmation",
    "upAFolder": "Up a folder",
    "home": "Home",
    "noFilesOrFoldersFound": "No files or folders found",
    "used": "Used",
    "filePreview": "File Preview",
    "fileUpload": "File Upload",
    "preview": "Preview",
    "previewUnavailable": "Unable to display a preview of this file.",
    "emptySheet": "This sheet is empty.",
    "dragAndDropFiles": "Drag and drop files here to upload.",
    "documentsVisibleNote": "Note: Documents are visible to all users within this location"
}

export const locations = {
    "locations": "Locations",
    "addLocation": "Add Location",
    "editLocation": "Edit Location",
    "completed": "Completed:",
    "issuesLeft": "Issues raised:",
    "missed": "Missed:",
    "address": "Address",
    "enabled": "Enabled",
    "updateLocation": "Update Location",
    "addNewLocation": "Add new location",
    "complianceByDay": "Compliance by day",
    "missedChecks": "Missed checks",
    "timesMissed": "Times missed",
    "enabledLocationSubscription": "Each enabled location will be added to your monthly subscription",
    "addingLocationAffectsSubscription": "Adding a location will affect your monthly subscription",
    "locationName": "Location Name",
    "addressLine1": "Address Line 1",
    "city": "City",
    "county": "County",
    "postalCode": "Postal code",
    "country": "Country",
    "locationIsEnabled": "Location is enabled",
    "locationIsDisabled": "Location is disabled",
    "locationDescription": "Each location is a kitchen within your account, you can have multiple locations each of which can have its own checks and records.",
    "locationSubscriptionNote": "The number of locations you have affect your subscription",
    "noMissedChecks": "No missed checks.",
    "fullyCompliant": "Your fully compliant!"
}

export const tenants = {
    "accounts": "Accounts",
    "company": "Company",
    "firstName": "First Name",
    "lastName": "Last Name",
    "password": "Password",
    "id": "Id"
}

export const menu = {
    "location": "Location",
    "accounts": "Accounts",
    "locations": "Locations",
    "users": "Users",
    "settings": "Settings",
    "myProfile": "My Profile",
    "help": "Help",
    "logout": "Logout",
    "notification": "Notification",
    "noNotifications": "No notifications",
    "version": "Version"
}

export const testTools = {
    "title": "Test Tools",
    "dataQueryTool": "Data Query Tool",
    "dataQueryDescription": "This tool runs a query against ALL tenants.",
    "sqlQuery": "SQL Query",
    "parameters": "Parameters",
    "emailTemplateTool": "Email Template Testing Tool",
    "emailTemplateDescription": "This tool allows sending test emails via the template building functions. Replacements are handled inside double curly braces",
    "toEmailAddress": "To Email Address",
    "emailHtmlBody": "Email HTML Body",
    "emailParameters": "Email Parameters"
}

export const settingsPage = {
    "createInvoice": "Create Invoice Subscription",
    "accountSettings": "Account Settings",
    "mySubscription": "My Subscription",
    "temperatures": "Temperatures",
    "otherSettings": "Other Settings",
    "subscriptionTypes": "Subscription types",
    "checkMateAdminOnly": "CheckMate admin only",
    "setTrialEnd": "Set trial end:",
    "reactivateAccount": "Re-activate account for 2 days",
    "isTrial": "Is Trial",
    "isAccountActive": "Is account active:",
    "hasSubscription": "Has Subscription:",
    "endDate": "End Date:",
    "stripeSubscriptionId": "Stripe Subscription Id:",
    "oneLocation": "{min} {max} locations:",
    "twoToTenLocations": "2 - 10 locations:",
    "elevenPlusLocations": "{min}+ locations:",
    "settingsSaved": "Settings saved",
    "settingsHaveBeenSaved": "Settings have been saved",
    "trialEndDateUpdated": "Trial end date updated",
    "calendar": "Calendar",
    "workingWeek": "Working week:",
    "freezerTemperatures": "Freezer Temperatures",
    "cookingTemperatures": "Cooking Temperatures",
    "coolingTemperatures": "Cooling Temperatures",
    "fridgeTemperatures": "Fridge Temperatures",
    "hotHoldingTemperatures": "Hot Holding Temperatures",
    "coldHoldingTemperatures": "Cold Holding Temperatures",
    "regenerationTemperatures": "Regeneration Temperatures",
    "hotProbeTemperatures": "Hot Probe Temperatures",
    "coldProbeTemperatures": "Cold Probe Temperatures",
    "temperatureSettingsDescription": "Your temperature settings can be tightened from here.",
    "editSubscriptionType": "Edit subscription type",
    "oneLocationLabel": "1 x location",
    "twoToTenLocationsLabel": "2 - 10 locations",
    "elevenPlusLocationsLabel": "11+ locations"
}